/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { getTopStoryClicks, updateDetailDateRange, clearDetailState } from 'state/actions/detailViewState/detailViewStatus';
import { viewAnalytics } from 'state/actions/embedsState/embeds_status';
// component
import TopStoryClicks from 'pages/dashboard/analytics/detail/metrics/topstoryclicks/topstoryclicks';



/* ========== ~~~~~~~~~~ DATA TOP STORY CLICKS : CONTAINER ~~~~~~~~~~ ========== */
//column head example {total: '', [`2019-01-01`]: 'Jan 1', [`2019-01-02`]: 'Jan 2', [`2019-01-03`]: 'Jan 3' }
//row of data example  { rank: '#1', topquestion: 'Which vitamin is essential for nervous system', answers: '3,765', embed: <Link type={`internal`} text={``} color={`primary`} action={`dashboard/`} icon={<Icon name={`external-link-alt`} />} />  }
const mapStateToProps = ({ homeState, detailViewStatus, sessionStatus, embedsState }) => ( {
    topStoryClicks: detailViewStatus.topStoryClicks,
    topStoryClicksFetching: detailViewStatus.topStoryClicksFetching,
    dateRange: detailViewStatus.dateRange,
    isDataReceived: embedsState.embedsStatus.isDataReceived,
    accountUUID: sessionStatus.accountUUID
});

// map actions
const mapDispatchToProps = dispatch => ({
    updateDateRange: range => dispatch(updateDetailDateRange(range)),
    getTopStoryClicks: ( paramString ) => dispatch(getTopStoryClicks(paramString)),
    clearDetailState: () => dispatch(clearDetailState()),
    viewAnalytics: (embedUUID, accountUUID) => dispatch(viewAnalytics(embedUUID, accountUUID))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TopStoryClicks);
